export default __webpack_public_path__ + "static/media/rick-logo.c3dd6203.jpg";